import React, { useState } from 'react';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import FabTitle from 'ui/structure/FabTitle/FabTitle';
import { servicesOptions, MobileSideMenu } from 'ui/structure/SideMenu';
import noop from 'utils/noop';

import styles from './HeaderMenu.module.css';

import burger from 'assets/icons/sidemenus-PNG/menu.png';

const HeaderMenu = () => {
  const [isMenuOpen, setMenuOpen] = useState(false);

  const handleOnClick = (open: boolean) => () => setMenuOpen(open);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <FabTitle />
        <div
          role="button"
          tabIndex={0}
          onClick={handleOnClick(!isMenuOpen)}
          onKeyPress={noop}
          className={styles.burger}
        >
          {isMenuOpen ? <CloseRoundedIcon /> : <img src={burger} alt="burger menu" />}
        </div>
        <MobileSideMenu
          items={[servicesOptions[1], servicesOptions[0], servicesOptions[2]]}
          isOpen={isMenuOpen}
          setOpen={setMenuOpen}
          menuClassName={styles.menu}
        />
      </div>
    </div>
  );
};

export default HeaderMenu;
